// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3a469b88","528":"65b0fd77"}[chunkId] + ".chunk.js";
};